import { render } from "./TheBorderStyle.vue?vue&type=template&id=eede8fda&ts=true"
import script from "./TheBorderStyle.vue?vue&type=script&lang=ts"
export * from "./TheBorderStyle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__